export const INC_NUMBER_OF_ORDERS = "INC_NUMBER_OF_ORDERS"
export const INC_NUMBER_OF_ORDER_NOTES = "INC_NUMBER_OF_ORDER_NOTES"
export const FETCH_NOT_VIEWED_ORDERS = "FETCH_NOT_VIEWED_ORDERS"
export const RESET_NOT_VIEWED_ORDERS = "RESET_NOT_VIEWED_ORDERS"